module.exports = __webpack_public_path__ + "static/img/icon-user_gold2.7d97c019.png";